import { Trans } from "@lingui/react/macro";

export const t_billingAccountOverrideNotice = (
    <Trans>
        Please note that the billing account linked to your storage bucket differs from the one associated with your
        storage account. We highly recommend aligning them for billing consistency and clearer management.
    </Trans>
);
